import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import NewOtherFeesContent from './NewOtherFeesContent';

const INIT_FILTER = {
  q: '',
  sort_by: 'desc',
};

function NewOtherFeesContainer({
  match,
  history,
  getNewOtherFeesList,
  newOtherFeesList,
  isLoading,
  removeNewOtherFees,
  newOtherFeesListPager,
  getSingleNewOtherFees,
  ordinanceRevisionId,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Add Other Fee',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          ordinanceRevisionId={ordinanceRevisionId}
          updateList={data.attributes}
          id={data.id}
          dataInfo={data}
        />
      ),
      title: 'Update Other Fee',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this other fee?',
      () => {
        removeNewOtherFees(data.id, () => {
          setFilter((prev) => ({
            ...prev,
            q: '',
          }));
          const id = _.get(newOtherFeesList, '1.id');
          history.push(`/bpls/tax-revenue/new-other-fees/${id}`);
          getSingleNewOtherFees(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    if (debouncedFilter?.ordinance_revision_id) {
      getNewOtherFeesList(debouncedFilter);
    }
  }, [JSON.stringify(debouncedFilter)]);

  useEffect(() => {
    if (ordinanceRevisionId) {
      setFilter((prev) => ({
        ...prev,
        ordinance_revision_id: ordinanceRevisionId,
      }));
    }
  }, [ordinanceRevisionId]);

  const handleOnChange = (key, value) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <Route
      path={`${match.path}/:newOtherFeesId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Other Fees"
          // getData={getNewOtherFeesList}
          // setParams={param}
          setKeyword={(e) =>
            handleOnChange(
              e?.target.name,
              e?.target.value
              // e?.target.value.length
            )
          }
          keyword={_.get(filter, 'q') || ''}
          keywordPlaceholder="Search..."
          listName="newOtherFees"
          label="Other Fees"
          renderItem={(item) => (
            <div className="px-3 py-3">
              {_.get(item, 'attributes.name')}
              <h4 className="mt-1 mb-0 transaction-list-name">
                {_.get(item, 'attributes.description')}
              </h4>
            </div>
          )}
          isLoading={isLoading}
          selected={params.newOtherFeesId}
          data={newOtherFeesList}
          dataPager={newOtherFeesListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:newOtherFeesId?`}
                  render={() => (
                    <NewOtherFeesContent
                      ordinanceRevisionId={ordinanceRevisionId}
                      handleAddModal={handleAddModal}
                      handleEdit={handleEdit}
                      handleRemove={handleRemove}
                      getNewOtherFeesList={getNewOtherFeesList}
                      // formData={formData}
                      // setFormData={setFormData}
                    />
                  )}
                />
              </Switch>
              <Route
                path={`${match.path}/:newOtherFeesId?`}
                render={() =>
                  !params.id && newOtherFeesList.length > 0 ? (
                    <Redirect
                      to={`${match.url}/${_.get(newOtherFeesList, '0.id')}`}
                    />
                  ) : null
                }
              />
            </React.Fragment>
          )}
          handleChangePage={(page) => setFilter((prev) => ({ ...prev, page }))}
          statusFilter
          hasOtherFeesFilter
          handleOnChange={handleOnChange}
          otherFeesFeeType={_.get(filter, 'fee_type') || ''}
          otherFeesType={_.get(filter, 'type') || ''}
        />
      )}
    />
  );
}

NewOtherFeesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  newOtherFeesList: PropTypes.instanceOf(Array).isRequired,
  newOtherFeesListPager: PropTypes.instanceOf(Object).isRequired,
  removeNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  newOtherFeesList: _.get(api, `${c.GET_NEW_OTHER_FEES}.list`) || [],
  newOtherFeesListPager: _.get(api, `${c.GET_NEW_OTHER_FEES}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_NEW_OTHER_FEES) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewOtherFeesContainer);
